/**
 * @deprecated
 * constants/colors.js — BACKWARD-COMPATIBILITY SHIM
 *
 * Color values are now centralised in constants/colorTokens.js,
 * which is auto-generated from src/assets/scss/_variables.scss.
 *
 * ► Prefer importing from colorTokens.js for all new code.
 * ► Run `npm run generate:colors` after editing _variables.scss.
 *
 * Named re-exports below map the old COLOR_* constants to their
 * nearest equivalent in the design-system palette.
 */

export {
  getCSSVar,
  getToken,
  colorTokens,
  CHART_COLORS,
  RISK_COLORS,
  DISPUTE_STATUS_COLORS,
  DISPUTE_PRIORITY_COLORS,
  INDUSTRY_COLORS,
  STRIPE_STYLE,
  PDF_TABLE_HEADER_COLOR,
  PDF_TABLE_HEADER_ALT,
  WINDOW_LOADER_BG_FROM,
  WINDOW_LOADER_BG_TO,
} from "./colorTokens";

import { colorTokens } from "./colorTokens";

// ---------------------------------------------------------------------------
// PRIMARY / BRAND  (mapped to $theme-color-palette equivalents)
// ---------------------------------------------------------------------------
export const COLOR_PRIMARY = colorTokens["primary"]; // #ff0d5e
export const COLOR_PRIMARY_DARK = colorTokens["primary-dark"]; // #cc0a4b
export const COLOR_PRIMARY_LIGHT = colorTokens["primary-light"]; // #fcbecf
export const COLOR_PRIMARY_HOVER = colorTokens["primary-dark"]; // #cc0a4b
export const COLOR_PRIMARY_ACTIVE = colorTokens["primary-darker"]; // #990838
export const COLOR_NAVY = colorTokens["secondary"]; // #7a29a8
export const COLOR_NAVY_DARK = colorTokens["secondary-darkest"]; // #2b0e3b

// ---------------------------------------------------------------------------
// STATUS
// ---------------------------------------------------------------------------
export const COLOR_SUCCESS = colorTokens["success-primary"]; // #38b95d
export const COLOR_SUCCESS_HOVER = colorTokens["success-dark"]; // #30914c
export const COLOR_SUCCESS_LIGHT = colorTokens["success-light"]; // #bfddc8
export const COLOR_SUCCESS_ALT = colorTokens["success-dark"]; // #30914c

export const COLOR_DANGER = colorTokens["danger-primary"]; // #ff2900
export const COLOR_DANGER_HOVER = colorTokens["danger-dark"]; // #cc2100
export const COLOR_DANGER_DARK = colorTokens["danger-dark"]; // #cc2100
export const COLOR_DANGER_LIGHT = colorTokens["danger-light"]; // #ffbdb0

export const COLOR_WARNING = colorTokens["warning-primary"]; // #ffc600
export const COLOR_WARNING_HOVER = colorTokens["warning-dark"]; // #cc9e00
export const COLOR_WARNING_LIGHT = colorTokens["warning-light"]; // #ffedb0

export const COLOR_INFO = colorTokens["info-primary"]; // #356de4
export const COLOR_INFO_HOVER = colorTokens["info-dark"]; // #2a57b6

// ---------------------------------------------------------------------------
// TEXT
// ---------------------------------------------------------------------------
export const COLOR_TEXT_PRIMARY = colorTokens["body-default"]; // #2a323a
export const COLOR_TEXT_SECONDARY = colorTokens["neutral-grey-primary"]; // #64748b
export const COLOR_TEXT_MUTED = colorTokens["neutral-grey-dark"]; // #334155
export const COLOR_TEXT_LIGHT = colorTokens["body-light"]; // #bdbfc2
export const COLOR_TEXT_DISABLED = colorTokens["neutral-grey-primary"]; // #64748b
export const COLOR_TEXT_TABLE = colorTokens["body-default"]; // #2a323a
export const COLOR_TEXT_DARK = colorTokens["body-darker"]; // #20262c

// ---------------------------------------------------------------------------
// BACKGROUND
// ---------------------------------------------------------------------------
export const COLOR_WHITE = colorTokens["basic-white"]; // #ffffff
export const COLOR_BG_LIGHT = colorTokens["bg-page"]; // #f9fafb
export const COLOR_BG_GRAY = colorTokens["neutral-grey-lighter"]; // #f1f5f9
export const COLOR_BG_HOVER = colorTokens["neutral-grey-lightest"]; // #f8fafc

// ---------------------------------------------------------------------------
// BORDER
// ---------------------------------------------------------------------------
export const COLOR_BORDER = colorTokens["neutral-grey-light"]; // #cbd5e1
export const COLOR_BORDER_MEDIUM = colorTokens["neutral-grey-light"]; // #cbd5e1
export const COLOR_BORDER_LIGHT = colorTokens["neutral-grey-lighter"]; // #f1f5f9
export const COLOR_BORDER_DARK = colorTokens["neutral-grey-primary"]; // #64748b
export const COLOR_BORDER_TABLE = colorTokens["neutral-grey-light"]; // #cbd5e1

// ---------------------------------------------------------------------------
// DARK
// ---------------------------------------------------------------------------
export const COLOR_BLACK = colorTokens["black"]; // #000000
export const COLOR_DARK = colorTokens["body-dark"]; // #22282e
export const COLOR_DARK_4 = colorTokens["body-darker"]; // #20262c

// ---------------------------------------------------------------------------
// CHART SPECIFIC  (individual named colors kept for legacy call-sites)
// ---------------------------------------------------------------------------
export const COLOR_CHART_BLUE = colorTokens["tertiary-sapphire-primary"]; // #356de4
export const COLOR_CHART_GREEN = colorTokens["success-primary"]; // #38b95d
export const COLOR_CHART_ORANGE = colorTokens["warning-primary"]; // #ffc600
export const COLOR_CHART_RED = colorTokens["danger-primary"]; // #ff2900
export const COLOR_CHART_GRAY = colorTokens["neutral-grey-primary"]; // #64748b
export const COLOR_CHART_LIME = colorTokens["neutral-mintgreen-primary"]; // #d7db61
export const COLOR_CHART_DKGREEN = colorTokens["tertiary-green-darker"]; // #246d39
export const COLOR_CHART_PINK = colorTokens["neutral-rose-primary"]; // #e362b4
export const COLOR_CHART_ORANGE_LIGHT = colorTokens["severity-moderate-high"]; // #ef6c00
export const COLOR_CHART_PRIMARY = colorTokens["charts-series-20"]; // #ff0d5e"

// ---------------------------------------------------------------------------
// React select theme style color overrides
// ---------------------------------------------------------------------------

export const COLOR_SELECT_THEME_CONFIG_LIGHT = {
  clearIndicator: (baseStyles) => ({
    ...baseStyles,
    color: colorTokens["primary"],
  }),
  control: (baseStyles, { isFocused, isDisabled }) => ({
    ...baseStyles,
    borderColor: isFocused
      ? colorTokens["tertiary-sapphire-primary"]
      : colorTokens["neutral-grey-light"],
    boxShadow: "none",
    backgroundColor: isDisabled
      ? colorTokens["neutral-grey-lighter"]
      : baseStyles.backgroundColor,
    "&:hover": {
      boxShadow: `1px 1px 1px 0px ${colorTokens["shadow-md"]}`,
    },
  }),
  dropdownIndicator: (baseStyles) => ({
    ...baseStyles,
    color: colorTokens["primary"],
    "& svg": {
      fill: colorTokens["primary"],
    },
  }),
  group: () => ({
    padding: 0,
    marginBottom: 8,
  }),
  groupHeading: (baseStyles) => ({
    ...baseStyles,
    fontWeight: 700,
    color: "var(--color-black)",
    textTransform: "none",
    fontSize: "inherit",
    cursor: "pointer",
    paddingTop: 5,
    paddingBottom: 5,
  }),
  indicatorSeparator: (baseStyles) => ({
    ...baseStyles,
    background: colorTokens["primary"],
  }),
  input: (baseStyles) => ({
    ...baseStyles,
  }),

  multiValue: (baseStyles) => ({
    ...baseStyles,
    borderRadius: "4px",
  }),
  multiValueLabel: (baseStyles) => ({
    ...baseStyles,
    backgroundColor: colorTokens["neutral-grey-lightest"],
    color: colorTokens["neutral-grey-dark"],
    borderTopLeftRadius: "4px",
    borderBottomLeftRadius: "4px",
  }),
  multiValueRemove: (baseStyles) => ({
    ...baseStyles,
    backgroundColor: colorTokens["neutral-grey-lightest"],
    color: colorTokens["neutral-grey-primary"],
    borderTopRightRadius: "4px",
    borderBottomRightRadius: "4px",
  }),
  option: (provided, { isSelected, isFocused }) => ({
    ...provided,
    padding: "5px 0 5px 10px",
    cursor: "pointer",
    backgroundColor: isSelected
      ? colorTokens["primary"] // selected bg
      : isFocused
        ? colorTokens["neutral-grey-lighter"] // hover/focus bg
        : provided.backgroundColor,
    color: isSelected
      ? colorTokens["basic-white"]
      : isFocused
        ? colorTokens["primary"]
        : provided.color,
  }),
  placeholder: (baseStyles) => ({
    ...baseStyles,
    color: colorTokens["neutral-grey-primary"],
  }),
};

// ---------------------------------------------------------------------------
// chart type based color palette
// ---------------------------------------------------------------------------

export const CHART_COLORS_45_LIST = [
  colorTokens["charts-series-1"],
  colorTokens["charts-series-2"],
  colorTokens["charts-series-3"],
  colorTokens["charts-series-4"],
  colorTokens["charts-series-5"],
  colorTokens["charts-series-6"],
  colorTokens["charts-series-7"],
  colorTokens["charts-series-8"],
  colorTokens["charts-series-9"],
  colorTokens["charts-series-10"],
  colorTokens["charts-series-11"],
  colorTokens["charts-series-12"],
  colorTokens["charts-series-13"],
  colorTokens["charts-series-14"],
  colorTokens["charts-series-15"],
  colorTokens["charts-series-16"],
  colorTokens["charts-series-17"],
  colorTokens["charts-series-18"],
  colorTokens["charts-series-19"],
  colorTokens["charts-series-20"],
  colorTokens["charts-series-21"],
  colorTokens["charts-series-1"],
  colorTokens["charts-series-2"],
  colorTokens["charts-series-3"],
  colorTokens["charts-series-4"],
  colorTokens["charts-series-5"],
  colorTokens["charts-series-6"],
  colorTokens["charts-series-7"],
  colorTokens["charts-series-8"],
  colorTokens["charts-series-9"],
  colorTokens["charts-series-10"],
  colorTokens["charts-series-11"],
  colorTokens["charts-series-12"],
  colorTokens["charts-series-13"],
  colorTokens["charts-series-14"],
  colorTokens["charts-series-15"],
  colorTokens["charts-series-16"],
  colorTokens["charts-series-17"],
  colorTokens["charts-series-18"],
  colorTokens["charts-series-19"],
  colorTokens["charts-series-20"],
  colorTokens["charts-series-21"],
  colorTokens["charts-series-1"],
  colorTokens["charts-series-2"],
  colorTokens["charts-series-3"],
];

export const CHART_TYPE_DONUT_COLORS = [
  colorTokens["charts-series-9"],
  colorTokens["charts-series-10"],
  colorTokens["charts-series-11"],
  colorTokens["charts-series-12"],
  colorTokens["charts-series-13"],
  colorTokens["charts-series-14"],
  colorTokens["charts-series-15"],
  colorTokens["charts-series-16"],
  colorTokens["charts-series-17"],
  colorTokens["charts-series-18"],
  colorTokens["charts-series-19"],
  colorTokens["charts-series-20"],
  colorTokens["charts-series-8"],
];

export const CHART_TYPE_BAR_COLORS = [
  colorTokens["charts-series-14"],
  colorTokens["charts-series-15"],
  colorTokens["charts-series-11"],
  colorTokens["charts-series-10"],
];

export const CHART_TYPE_STACKED_BAR_COLORS = [
  colorTokens["charts-series-9"],
  colorTokens["charts-series-10"],
  colorTokens["charts-series-11"],
  colorTokens["charts-series-12"],
  colorTokens["charts-series-13"],
  colorTokens["charts-series-3"],
  colorTokens["charts-series-19"],
  colorTokens["charts-series-16"],
  colorTokens["charts-series-17"],
];

export const CHART_TYPE_LINE_COLORS = [
  colorTokens["charts-series-9"],
  colorTokens["charts-series-10"],
  colorTokens["charts-series-12"],
  colorTokens["charts-series-6"],
  colorTokens["charts-series-13"],
];

export const CHART_TYPE_AREA_COLORS_PALETTE_1 = [
  colorTokens["charts-series-9"],
  colorTokens["charts-series-10"],
  colorTokens["charts-series-12"],
  colorTokens["charts-series-6"],
  colorTokens["charts-series-13"],
];

export const CHART_TYPE_AREA_COLORS_PALETTE_2 = [
  colorTokens["charts-series-20"],
  colorTokens["charts-series-17"],
  colorTokens["charts-series-21"],
  colorTokens["charts-series-8"],
  colorTokens["charts-series-19"],
];

export const CHART_TYPE_AREA_COLORS_PALETTE_3 = [
  colorTokens["charts-series-1"],
  colorTokens["charts-series-2"],
  colorTokens["charts-series-3"],
  colorTokens["charts-series-4"],
  colorTokens["charts-series-5"],
];

export const CHART_TYPE_INVOICE_STATUS = [
  colorTokens["status-paid"],
  colorTokens["status-current"],
  colorTokens["status-overdue"],
  colorTokens["status-unpaid"],
  colorTokens["status-billed"],
  colorTokens["status-partially-received"],
  colorTokens["status-fulfillment"],
  colorTokens["status-fulfilled"],
  colorTokens["status-pending"],
  colorTokens["status-open"],
];

// This shade color token is applied to  any chart if need for same shade
// note : for now we only have secondary color token shades defined
export const CHART_TYPE_SHADES_COLOR_TOKENS = [
  colorTokens["charts-series-1"],
  colorTokens["charts-series-6"],
  colorTokens["charts-series-3"],
  colorTokens["charts-series-8"],
  colorTokens["charts-series-5"],
  colorTokens["charts-series-7"],
  colorTokens["charts-series-2"],
  colorTokens["charts-series-4"],
  colorTokens["charts-series-5"],
];
